import React from 'react';

function ClientSettingPassword(){

    return (
       
        <>
<div class="col-sm-7">
        
               <div className="card" style={{ width: "18rem;" }}>
        <div className="card-body">
          <div style={{ display: "flex" }}>
          <p className="card-title">
                <strong> Change your password</strong>{" "}
                
              </p>
          

            <span className="leftAling" style={{ display: "flex" }}>
          
              <span className="info">
                <span class="material-symbols-rounded">more_horiz</span>
              </span>
            </span>
          </div>

   
          <hr />


          <div class="row">

<div class="col-sm-12">

</div>

    <div class="col-sm-4">


          <div className="">

          <div className="smallInfo" style={{ display: "flex" }}>
              <span class="material-symbols-rounded writing">
                lock
              </span>{" "}
              <span style={{ marginTop: "-3px", paddingLeft: "5px", paddingBottom:"10px" }}>
                <strong>
                  Current Password:
                </strong>
              </span>
           
            </div>
        
            <input
            type="password"
            className="Login-form-field Login-animation a4"
            name=""
            placeholder="passowrd"
            style={{ width:"90%" }}
            />
        </div>
    </div>

    <div class="col-sm-4">
          <div className="">

        <div className="smallInfo" style={{ display: "flex" }}>
              <span class="material-symbols-rounded writing">
              lock
              </span>{" "}
              <span style={{ marginTop: "-3px", paddingLeft: "5px", paddingBottom:"10px" }}>
                <strong>
                  New Password:
                </strong>
              </span>
           
        </div>
         
            <input
            type="password"
            className="Login-form-field Login-animation a4"
            name=""
            placeholder="New password"
            style={{ width:"90%" }}
            />
        </div>
    </div>
    <div class="col-sm-4">


<div className="">

<div className="smallInfo" style={{ display: "flex" }}>
              <span class="material-symbols-rounded writing">
              lock
              </span>{" "}
              <span style={{ marginTop: "-3px", paddingLeft: "5px", paddingBottom:"10px" }}>
                <strong>
                  Confirm new password:
                </strong>
              </span>
           
        </div>

  <input
  type="password"
  className="Login-form-field Login-animation a4"
  name=""
  placeholder="New password"
  style={{width:"90%" }}
  />
</div>
</div>



</div>


<hr style={{marginTop:"40px", marginBottom:"20px"}} />


<button className="btn2 btn-default" style={{marginRight:"20px"}} >Update</button>


        </div>
      </div>
      </div>
        </>
    )
}

export default ClientSettingPassword;